var map = {
	"./archive.png": 5913,
	"./document.png": 9544,
	"./excel.png": 5482,
	"./pdf.png": 7273,
	"./pictureIcon.png": 2446,
	"./powerpoint.png": 6764,
	"./rar.png": 1508,
	"./word.png": 9728
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4019;